import Mutations from '../../odata/mutations';

export default { ...new Mutations('stockItemAlternative'), ...new Mutations('stockItemAlternatives') };
